export const STREET_NAME_PLAQUE_RENDER_CONFIG = Object.freeze({
  poleHeightM: 3.05,
  poleRadiusM: 0.045,
  plaqueCenterHeightM: 2.62,
  plaqueHeightM: 0.38,
  plaqueDepthM: 0.055,
  minimumPlaqueWidthM: 0.9,
  maximumPlaqueWidthM: 2.35,
  characterWidthM: 0.115,
  junctionAlongOffsetM: 1.25,
  fallbackAlongStepM: 0.8,
  fallbackAttemptCount: 16,
  roadsideClearanceM: 0.58,
  otherRoadPlaqueClearanceM: 0.24,
  buildingClearanceM: 0.18,
  treeClearanceM: 0.38,
  surfaceLiftM: 0.012,
  maximumLabelCharacters: 20,
});
